// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"dd5733b9","703":"415f9f30"}[chunkId] + ".chunk.js";
};